import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Закрепить/открепить сигнала
export const apiPinSignal = async ({ id, methodType }) => {
  try{
    const url = `${backendUrl}/api/signals/pin/${id}/`;
    const options = {
      method: methodType,
      headers: { 'Content-Type': 'application/json' },
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при прикриплении/откреплении сигнала: HTTP error! Status: ${ response.status }`);
    }
    return response;
  } catch(error){
    console.error('Программная ошибка прикриплении/откреплении сигнала:', error);
    throw error;
  }
};